import React, { useEffect } from "react";
import tick from "../assets/tick.png";
import curveLine from "../assets/curveLine.png";
import { RiDoubleQuotesL } from "react-icons/ri";
import service_img from "../assets/service_img.png";
import serviceTexture from "../assets/service_texture.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-scroll";
const serviceFeatures = [
  { text: "Guardian Verification" },
  { text: "100% Guardian Involvement" },
  { text: "Halal Interactions" },
  { text: "Compatibility Matching" },
  { text: "Monitored Interactions" },
  { text: "Free Chats and Calls" },
];

function ServicesComponent() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  return (
    <div id="services" className=" w-full bg-[#fff]">
      <div className="md:w-[90%] lg:w-[80%] m-auto flex gap-5  max-md:flex-col py-16">
        <div
          data-aos="fade-right"
          className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full px-5 sm:px-10 md:px-0"
        >
          <div className="flex flex-col grow max-md:mt-10 max-md:max-w-full">
            <div className="self-start text-6xl leading-none text-secondColor font-yeseva max-md:text-4xl">
              <RiDoubleQuotesL />
            </div>
            <div className="flex flex-col pl-1.5 w-full max-md:max-w-full">
              <h2 className="text-3xl sm:text-4xl leading-[51px] text-themeColor font-yeseva ">
                Services <br />
              </h2>
              <h1 className="self-start font-yeseva text-4xl leading-none text-slate-950  sm:text-5xl">
                <span>We're </span>
                <span className="text-secondColor">Offering</span>
              </h1>
              <p className="mt-5 font-light leading-7 font-poppins text-black max-md:max-w-full">
                At <span className="text-themeColor font-yeseva">My Wali </span>
                we offer a range of services to ensure a seamless, respectful
                journey to finding your spouse, with a focus on guardian
                involvement for guidance and support throughout the process.
              </p>
              <img className="w-32 mt-5" src={curveLine} alt="" />

              <div className="mt-6 max-md:max-w-full">
                <div className="w-full">
                  <div className="items-start grid grid-cols-12 w-full text-sm font-poppins leading-none font-[500] max-md:mt-6">
                    {serviceFeatures.map((feature, index) => (
                      <div className="col-span-12 sm:col-span-6  flex gap-3 items-center mt-3">
                        <img
                          loading="lazy"
                          src={tick}
                          alt=""
                          className="object-contain shrink-0 aspect-square w-[23px]"
                        />
                        <div className="basis-auto leading-5">
                          {feature.text}
                        </div>
                      </div>
                    ))}
                  </div>
                  <button className="font-yeseva transition-all duration-300 hover:scale-105  gap-2.5 self-stretch px-10 py-3.5 mt-14 sm:text-xl text-white bg-themeColor min-h-[60px] rounded-[45px] max-md:px-5 max-md:mt-10">
                    <Link to="contact" duration={500} offset={-70}>
                      Register Now
                    </Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-left"
          className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full items-center justify-center px-10"
        >
          <div className="w-full lg:w-[90%] flex flex-col mt-20 items-center justify-center text-white max-md:mt-10 max-md:max-w-full">
            <img loading="lazy" src={service_img} className="" />
            {/* <div className="mt-10 sm:mt-20 sm:w-[350px] lg:w-[430px] h-[130px] rounded-2xl bg-themeColor">
              <div
                className="w-full h-full px-5 pt-5 rounded-2xl"
                style={{
                  background: `url(${serviceTexture})`,
                  backgroundSize: "cover",
                }}
              >
                <h1 className="font-yeseva text-lg sm:text-2xl">Join Us Now</h1>
                <p className="relative mt-2 text-[10px] sm:text-[12px] font-poppins leading-3 sm:leading-5">
                  We ensure every service upholds respect and integrity in your
                  journey to finding a meaningful partner.
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesComponent;
